import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import clientInformation, { setClientItem, getClientItem } from '../login/ClientInfo';
import Alerts from '../helpers/Alerts';
import { IsValidToken } from "../../services/AuthenticationService";
import { GetPayoutsLimits } from "../../services/PayoutService";
import { GetExpressLimits } from "../../services/DepositService";
import Loading from '../helpers/Loader';
import { useTranslations } from '../../context/LanguageContext';
import translations from '../../translations/PayoutMethods';

export const PayoutMethods = () => {
    const t = useTranslations(translations);
    const clientInfo = clientInformation();
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isLoading, setIsLoading] = useState(true);
    const [arrayPayouts, setArrayPayouts] = useState([]);
    const [disableExpress, setDisableExpress] = useState(false);
    const navigate = useNavigate();
    let HideNavigation = process.env.REACT_APP_HideNavigation;

    const mode = getClientItem('Mode');
    const hideNav = HideNavigation == 'true' || mode === 'Deposit' || mode === 'Withdrawal';

    useEffect(() => {

        IsValidToken(getClientItem('Token')).then(async function (response) {
            await PayoutsLimits();
            await ExpressDepositsLimits();
        }

        ).catch(function (error) {
            navigate('/expired/');
        })

    }, []);

    async function ExpressDepositsLimits() {
        await GetExpressLimits(getClientItem('Token')).then(async function (response) {
            if (response.Authentication.length === 0) {
                setDisableExpress(true);
            }
        });
    }

    async function PayoutsLimits() {
        await GetPayoutsLimits(getClientItem('Token'), clientInfo.CurrencyCode, clientInfo.AvailableBalance).then(async function (response) {

            var i = 0;

            const filtered = response.Authentication.map(item => {

                const {
                    IconURL,
                    ImageName,
                    MaxPayout,
                    MinPayout,
                    PaymentType,
                    PayoutID,
                    PayoutName,
                    ProcessorID
                } = item;
                if (item.PaymentType.toLowerCase() === "credit card" ||
                    item.PaymentType.toLowerCase() === "crypto" ||
                    item.PaymentType.toLowerCase() === "check" ||
                    item.PaymentType.toLowerCase() === "money gram" ||
                    item.PaymentType.toLowerCase() === "generic" ||
                    item.ImageName.toLowerCase() === "tylt" ||
                    item.PaymentType.toLowerCase() === "ach" ||
                    item.PaymentType.toLowerCase() === "wire transfer" ||
                    item.ImageName.toLowerCase() === "r4conecta" ||
                    (item.PaymentType === "EWallet" &&
                        item.ImageName.toLowerCase() === "venmo" ||
                        item.ImageName.toLowerCase() === "zelle" ||
                        item.ImageName.toLowerCase() === "cashapp" ||
                        item.ImageName.toLowerCase() === "applepay" ||
                        item.ImageName.toLowerCase() === "paypal"
                    )
                ) {
                    return {
                        Key: i++,
                        IconURL,
                        ImageName,
                        MaxPayout,
                        MinPayout,
                        PaymentType,
                        PayoutID,
                        PayoutName,
                        ProcessorID
                    };
                }
            });
            await setArrayPayouts(filtered.filter(function (element) { return element !== undefined; }));
            setIsLoading(false);
            await setClientItem('arrayPayoutsMethods', JSON.stringify(filtered.filter(function (element) { return element !== undefined; })));

        }).catch(function (error) {
            setIsLoading(false);
            clientInfo.Error = false;
            Alerts.ShowAlert(t.error, t.errorGettingLimits + error.response.data.Authentication.ErrorDescription, 'error');


        })
    }

    function GetFormURL(Key) {
        if (arrayPayouts[Key].PaymentType.toLowerCase() === "credit card")
            return "/payouts/creditcard/"
        else if (arrayPayouts[Key].PaymentType.toLowerCase() === "crypto")
            return "/payouts/crypto/" + arrayPayouts[Key].PayoutID
        else if (arrayPayouts[Key].PaymentType.toLowerCase() === "money gram")
            return "/payouts/moneygram/"
        else if (arrayPayouts[Key].PaymentType.toLowerCase() === "check")
            return "/payouts/check/" + arrayPayouts[Key].PayoutID
        else if (arrayPayouts[Key].PaymentType.toLowerCase() === "ach")
            return "/payouts/ach/" + arrayPayouts[Key].PayoutID
        else if (arrayPayouts[Key].PaymentType.toLowerCase() === "wire transfer")
            return "/payouts/wiretransfer/" + arrayPayouts[Key].PayoutID
        else if (arrayPayouts[Key].ImageName.toLowerCase() === "tylt")
            return "/payouts/wallet/" + arrayPayouts[Key].PayoutID
        else if (arrayPayouts[Key].ImageName.toLowerCase() === "venmo"
            || arrayPayouts[Key].ImageName.toLowerCase() === "zelle"
            || arrayPayouts[Key].ImageName.toLowerCase() === "cashapp"
            || arrayPayouts[Key].ImageName.toLowerCase() === "applepay"
            || arrayPayouts[Key].ImageName.toLowerCase() === "paypal") {
            return "/payouts/wallet/" + arrayPayouts[Key].PayoutID
        }
        else if (arrayPayouts[Key].ImageName.toLowerCase() === "r4conecta")
            return "/payouts/r4conecta/" + arrayPayouts[Key].PayoutID
        else if (arrayPayouts[Key].PaymentType.toLowerCase() === "generic") {
            return "/payouts/generic/" + arrayPayouts[Key].ProcessorID
        }
        else
            return "";
    }

    if (isLoading) {
        return <Loading />;
    }

    const handleMethodSelect = (name) => {
        navigate(`/deposits/${name}`);
    }

    const handleExpressSelect = () => {
        navigate(`/main/`);
    }

    return (
        <div className="mt-3 componentload">
            <div className="title">
                <div className="container">
                    <h4 className="txt-primary payout-title-color mb-4">{t.title}</h4>
                </div>
            </div>
            <div className="row" style={{ display: 'none' }}>
                {hideNav ? <div></div> :
                    (disableExpress == false) ?
                        <div className="col-xxl-6 col-md-6 col-sm-6 col-xs-6">
                            <div onClick={() => handleExpressSelect()} className="box-deposit express-color mb-4 text-center text-wrap" >
                                <span className="othermethod-text text-center">{t.expressDeposit}</span>
                            </div>
                        </div>
                        :
                        <div className="col-xxl-6 col-md-6 col-sm-6 col-xs-6" title={t.expressDisabledTitle}>
                            <div className="box-deposit express-color-disabled mb-4 text-center text-wrap" >
                                <span className="othermethod-text text-center">{t.expressDeposit}</span>
                            </div>
                        </div>
                }
                {hideNav ? <div></div> :
                    <div className="col-xxl-6 col-md-6 col-sm-6 col-xs-6">
                        <div onClick={() => handleMethodSelect('')} className="box-deposit  othermethod-color mb-4 text-center text-wrap " >
                            <span className="othermethod-text text-center ">{t.useOtherDeposit}</span>
                        </div>
                    </div>
                }
            </div>
            <div className="row">
                {arrayPayouts.map((item) => (
                    <div className="col-xxl-4 col-md-4 col-sm-6 col-xs-6">
                        <Link key={item.Key} to={GetFormURL(item.Key)} className="box-deposit  mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-12">
                                    <div className="image-wrapper">
                                        <span className="icon-single">
                                            {(item.PaymentType === 'Generic') ?
                                                <img alt="" src={"data:image/svg+xml;base64," + item.ImageName} />
                                                :
                                                <img alt="" src={"/svg/" + item.ImageName + ".svg"} />
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-12 text-center limit-text">
                                    <span>{t.min}:${item.MinPayout === 0 ? 1 : item.MinPayout} - {t.max}:{item.MaxPayout === 0 ? t.noLimit : '$' + item.MaxPayout}</span>
                                </div>
                                <div className="col-md-3 limit-text d-none d-md-block ">

                                </div>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
            {HideNavigation == 'true' ? <div></div> :
                <div className="row">
                    <div className="col-12 actionbuttons mt-3">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4 " onClick={() => navigate('/deposits/')}>{t.back}</button>
                    </div>
                </div>
            }
        </div>
    )
}
